import { render, staticRenderFns } from "./DocumentRequestComplete.vue?vue&type=template&id=6ddef544&scoped=true&"
import script from "./DocumentRequestComplete.vue?vue&type=script&lang=js&"
export * from "./DocumentRequestComplete.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRequestComplete.vue?vue&type=style&index=0&id=6ddef544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddef544",
  null
  
)

export default component.exports